import { Guid } from '../../../model/guid';
import { ItemsReducerState } from '../../../reducers/items/itemsReducer';
import { GetItemById } from '../../../reducers/items/itemsSelectors';
import { getHotspotTab } from '../trackingPersistenceMiddleware';
import {
  createGetItemByIdFromItemsReducerState,
  createGetMaybeItemByIdFromItemsReducerState,
} from './getItemByIdFromItemsReducerState';
import { ensureNonSequencedFlowItem, Hotspot, isHotspotTab, isNonSequencedFlowItem, Item } from '@ael/core-api';
import { List } from 'immutable';

export const getParentCreator =
  (getItems: () => ItemsReducerState) =>
  (childId: Guid): Guid | null => {
    const items = getItems();
    const getItemById = createGetItemByIdFromItemsReducerState(items);
    const getItemByIdAllowUndefined = createGetMaybeItemByIdFromItemsReducerState(items);
    const child = getItemByIdAllowUndefined(childId) || getHotspotTab(childId, items, getItemById);
    if (!child) {
      return null;
    }
    if (isHotspotTab(child)) {
      const hotspotMap = items
        .filter((item: Item) => isNonSequencedFlowItem(item))
        .find((nonSequencedFlowItem: Item) => {
          ensureNonSequencedFlowItem(nonSequencedFlowItem);
          return !!nonSequencedFlowItem.hotspots.find((hotspotId: Guid) =>
            hotspotContainsGivenTab(childId, hotspotId, getItemById)
          );
        });
      if (hotspotMap) {
        return hotspotMap.id;
      }
    }
    // We don't need other parents than nonsq and presenter
    return null;
  };

const hotspotContainsGivenTab = (tabId: Guid, hotspotId: Guid, getItemById: GetItemById): boolean => {
  return getHotspotsTabIds(hotspotId, getItemById).contains(tabId);
};

const getHotspotsTabIds = (hotspotId: Guid, getItemById: GetItemById): List<Guid> => {
  return (getItemById(hotspotId) as Hotspot).tabs;
};
